import { FC } from "react";
import { useSearchParams } from "react-router-dom";
import { Link, Text } from "@fluentui/react-components";
import { useGeneralStyles } from "./styles";

interface OnlinePaymentProps {}
//export const queryClient = new QueryClient();

const OnlinePayment: FC<OnlinePaymentProps> = () => {
  const generalStyles = useGeneralStyles();
  const [searchParams] = useSearchParams();
  const amount = searchParams.get("amount");

  return (
    <Text className={generalStyles.body2}>
      If you completed your payment via Paypal with the window that just opened then your official registration is now pending. Your
      membership status will be updated as soon as our treasurer confirms your payment.  
      <br/>
      <br/>
      You can login now using the button in the top right corner.
      <br />
      <br />A receipt for your purchase in the amount of ${amount} will be
      emailed to you. You may log into your PayPal account at &nbsp;
      <Link
        href="https://www.paypal.com"
        target="_blank"
        color="text.secondary"
      >
        www.paypal.com
      </Link>&nbsp;
      to review the details of this transaction.
    </Text>
  );
};

export default OnlinePayment;
